<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="VERWIJDER PARTITION"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <div>
        <p style="padding-left:11px;">Weet je zeker dat je de PBX-groep met alle diensten en nummers, inclusief de orderregels, wilt beëindigen?</p>
      </div>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import axios from 'axios';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {FadeTransition} from 'vue2-transitions';
import {getErrorCodeFromResponse, getErrorFromResponse} from "@/mixins/errorMessage";

@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class TerminatePartitionDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public save() {
      this.$emit('setLoad', true);

      axios.post('/-/trade/api/cloudVoice.orders.cancel.all', {
        customerId: this.payloadData.customerId,
      }).then(
        (response: any) => {
          deanDialogBus.$emit('saved');

          this.$toast(this.$store.state.main.notification.messages.partitionTerminated);

          this.close();
        },
        (error: any) => {
          const errorMessage: string|null = getErrorFromResponse(
              error.response.data,
              'Request failed.'
          );

          this.$toast({
            icon: warningIcon,
            text: errorMessage ?? '',
            theme: 'danger',
          });
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container) {
  width: 500px;
}

</style>
